import { BillingSewRegionEnum } from '@/backoffice/types/types.generated';

export const SEW_BILLING_REGION_LABELS: Record<BillingSewRegionEnum, string> = {
  [BillingSewRegionEnum.Belgium]: 'Belgium - 14056',
  [BillingSewRegionEnum.Finland]: 'Finland - 14020',
  [BillingSewRegionEnum.France]: 'France - 17500',
  [BillingSewRegionEnum.Germany]: 'Germany - 00000',
  [BillingSewRegionEnum.Italy]: 'Italy - 16014',
  [BillingSewRegionEnum.Korea]: 'Korea - 18180',
  [BillingSewRegionEnum.Netherlands]: 'Netherlands - 14192',
  [BillingSewRegionEnum.Uk]: 'UK - 16013',
  [BillingSewRegionEnum.Usa]: 'USA - 18566',
};

export const SEW_BILLING_REGION_OPTIONS = (
  Object.entries(SEW_BILLING_REGION_LABELS) as [BillingSewRegionEnum, string][]
).map(([value, label]) => ({ label, value }));

export const getSewBillingRegionLabel = (value?: string | null) => {
  if (!value) return value;

  return SEW_BILLING_REGION_LABELS[value as BillingSewRegionEnum] ?? value;
};
